<template>
    <span>
        <a @click="openmodel()">任务情况</a>
        <a-modal :visible="modelvisible" :destroyOnClose="true" :width="1680" title="任务列表" @ok="okmodel"
            @cancel="cancelmodel">

            <div class="main">
                <a-descriptions title="学生信息">
                    <a-descriptions-item label="姓名">
                        {{ itemdata.nickname }}
                    </a-descriptions-item>
                    <a-descriptions-item label="当前时间">
                        {{ moment(time).format('lll') }}
                    </a-descriptions-item>
                </a-descriptions>
                <a-tabs class="row" type="card">
                    <a-tab-pane tab="当前任务" key="nowmission">

                        <a-table :dataSource="usermissionlist" :rowKey="item => item.id">
                            <a-table-column key="name" title="任务名字" data-index="name" />
                            <a-table-column key="mission_type_id2" title="任务类型" data-index="mission_type_id">
                                <template slot-scope="text, item">
                                    <a-tag style="background-color:#0000CC;color:white" v-if="item.mission_type_id == 'zwyx'">
                                        自我预习
                                    </a-tag>
                                    <a-tag style="background-color:#0055AA;color:white" v-if="item.mission_type_id == 'zwjc'">
                                        自我检测
                                    </a-tag>
                                    <a-tag style="background-color:#00FF00;color:white" v-if="item.mission_type_id == 'zwgg'">
                                        自我巩固
                                    </a-tag>
                                    <a-tag style="background-color:#0782C1;color:white" v-if="item.mission_type_id == 'zwsx'">
                                        自我实现
                                    </a-tag>
                                    <a-tag style="background-color:#2D2D2D;color:white" v-if="item.mission_type_id == 'jdcs'">
                                        阶段测试
                                    </a-tag>

                                </template>
                            </a-table-column>
                            <a-table-column key="mission_status" title="任务状态" data-index="mission_status">
                                <template slot-scope="text, item">
                                    <a-tag style="background-color:firebrick;color:white" v-if="item.mission_status == 1">
                                        未完成
                                    </a-tag>
                                    <a-tag style="background-color:skyblue;color:white" v-if="item.kcnmission == 2">
                                        已超时
                                    </a-tag>
                                    <a-tag style="background-color:#00FF00;color:white" v-if="item.kcnmission == 3">
                                        已完成
                                    </a-tag>
                                </template>
                            </a-table-column>

                            <a-table-column key="start_time" title="时间">
                                <template slot-scope="item">
                                    {{ moment(item.start_time * 1000).format('lll') }}至 {{ moment(item.end_time *
                                        1000).format('lll') }}
                                </template>

                            </a-table-column>
                        </a-table>

                    </a-tab-pane>
                    <a-tab-pane tab="所有任务" key="allmission">
                        <a-table :dataSource="userallmissionlist" :rowKey="item => item.id" :pagination="pageinfo"
                            @change="onPaginationChange">
                            <a-table-column key="name" title="任务名字" data-index="name" />
                            <a-table-column key="mission_type_id2" title="任务类型" data-index="mission_type_id">
                                <template slot-scope="text, item">
                                    <a-tag style="background-color:#0000CC;color:white" v-if="item.mission_type_id == 'zwyx'">
                                        自我预习
                                    </a-tag>
                                    <a-tag style="background-color:#0055AA;color:white" v-if="item.mission_type_id == 'zwjc'">
                                        自我检测
                                    </a-tag>
                                    <a-tag style="background-color:#00FF00;color:white" v-if="item.mission_type_id == 'zwgg'">
                                        自我巩固
                                    </a-tag>
                                    <a-tag style="background-color:#0782C1;color:white" v-if="item.mission_type_id == 'zwsx'">
                                        自我实现
                                    </a-tag>
                                    <a-tag style="background-color:#2D2D2D;color:white" v-if="item.mission_type_id == 'jdcs'">
                                        阶段测试
                                    </a-tag>
                                    <a-tag style="background-color:#316AC5;color:white" v-if="item.mission_type_id == 'mryl'">
                                        每日一练
                                    </a-tag>

                                </template>
                            </a-table-column>
                            <a-table-column key="mission_status" title="任务状态" data-index="mission_status">
                                <template slot-scope="text, item">
                                    <a-tag style="background-color:firebrick;color:white" v-if="item.mission_status == 1">
                                        未完成
                                    </a-tag>
                                    <a-tag style="background-color:skyblue;color:white" v-if="item.mission_status == 2">
                                        已超时
                                    </a-tag>
                                    <a-tag style="background-color:#00FF00;color:white" v-if="item.mission_status == 3">
                                        已完成
                                    </a-tag>
                                </template>
                            </a-table-column>

                            <a-table-column key="start_time" title="时间">
                                <template slot-scope="item">
                                    {{ moment(item.start_time * 1000).format('lll') }}至 {{ moment(item.end_time *
                                        1000).format('lll') }}
                                </template>

                            </a-table-column>
                        </a-table>


                    </a-tab-pane>
                    <a-tab-pane tab="课程安排" key="course">

                    </a-tab-pane>
                </a-tabs>
            </div>
        </a-modal>

    </span>
</template>


<script>
import moment from "moment";
export default {
    components: {

    },
    props: {
        itemdata: {}
    },
    data() {
        return {
            time: Date.parse(new Date()),
            modelvisible: false,
            loading: false,
            usermissionlist: undefined,
            userallmissionlist: undefined,
            pageinfo: {
                total: 1,
                current: 1,
                pageSize: 10,
                allCnt: 0
            },
        }

    },
    mounted() {
        this.squad_id = this.itemdata.squad_id;

    },

    methods: {

        onPaginationChange(item) {
            this.pageinfo.current = item.current;
            this.getallSquadMissList();
        },

        getSquadMissList() {
            this.$axios
                .post("/api/UserMission/getusermissionlist", {
                    data: {
                        user_id: this.itemdata.user_id,
                        squad_id: this.itemdata.squad_id,
                        teacher_check: 0,
                        current_mission: 0,
                    }
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.usermissionlist = res.data.data;
                        this.pageinfo = res.data.pageinfo;
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },
        getallSquadMissList() {
            this.$axios
                .post("/api/UserMission/getusermissionlist", {
                    data: {
                        user_id: this.itemdata.user_id,
                        squad_id: this.itemdata.squad_id,
                    },
                    pageinfo: this.pageinfo
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                    } else {
                        this.userallmissionlist = res.data.data;
                        this.pageinfo = res.data.pageinfo;
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        },


        openmodel() {
            this.modelvisible = true;
            this.getSquadMissList();
            this.getallSquadMissList();
        },
        okmodel() {
            this.modelvisible = false;
        },
        cancelmodel() {
            this.modelvisible = false;
        },
        moment
    },

};
</script>


<style lang="less" scoped>
.main {
    margin-top: 1.5rem;
}

.row {
    margin-top: 1rem;
}

.title {
    font-weight: 700;
    font-family: 微软雅黑, tahoma;
}

.page {
    display: flex;
    justify-content: space-between;
}</style>
